/**
 * 全量往搜索列表插入热门推荐商品
 * @param {*} dataSorce
 * @param {*} recommendgoodResult
 * @returns
 */
// export function insertHotGoods(dataSorce, recommendgoodResult) {
//   const _searchesList = [...dataSorce];
//   const { advertisingSpacs } = (recommendgoodResult && recommendgoodResult.data) || {};

//   if (!advertisingSpacs || advertisingSpacs.length <= 0) {
//     return _searchesList;
//   }

//   advertisingSpacs.forEach(advertising => {
//     let index = advertising.index <= 0 ? 0 : advertising.index - 1; // 减去1 代表插入前面，
//     let goodIndex = 0;

//     for (let i = 0; i < _searchesList.length; i++) {
//       const item = _searchesList[i];
//       const isNotGood = [1, 2].includes(+(item.bizType || 0)); // 投放和坑位

//       const isBeyond = index > _searchesList.length; // 超出边界
//       if (isBeyond) {
//         break;
//       }

//       if (index == goodIndex) {
//         if (isNotGood) {
//           ++index;
//           goodIndex++;
//           continue;
//         }

//         if (!isNotGood && !item.goods) {
//           // 索引匹配，已经是推荐位，就不用替换了
//           _searchesList.splice(i, 0, advertising);
//         }
//         break;
//       }

//       if (isNotGood || item.goods) {
//         // 过滤掉投放和坑位
//         goodIndex = +goodIndex;
//         continue;
//       }

//       goodIndex++;
//     }
//   });
//   return _searchesList;
// }

/**
 * 非全量往搜索列表插入热门推荐商品
 * @param {*} dataSorce
 * @param {*} recommendgoodResult
 * @returns
 */
export function insertHotGoodsByPageIndex(searchList, advertisingSpacsInfo) {
  searchList = searchList || [];
  const { insertIndex, advertisingSpacs } = advertisingSpacsInfo || {};
  if (!advertisingSpacs || advertisingSpacs.length <= 0) {
    return {
      insertIndex,
      advertisingSpacs,
      _searchesList: searchList,
    };
  } else {
    const _searchesList = [...searchList];
    let _insertIndex = insertIndex;
    let _advertisingSpacs = [...advertisingSpacs];

    advertisingSpacs.forEach(advertising => {
      const startIndex = advertising.index - (_insertIndex || 0);

      let index = startIndex <= 0 ? 0 : startIndex - 1; // 减去1 代表插入前面，
      let goodIndex = 0;

      for (let i = 0; i < _searchesList.length; i++) {
        const item = _searchesList[i];
        const isNotGood = [1, 2].includes(+(item.bizType || 0)); // 投放和坑位
        const isBeyond = index > _searchesList.length; // 超出边界
        if (isBeyond) {
          break;
        }

        if (index == goodIndex) {
          if (isNotGood) {
            ++index;
            goodIndex++;
            continue;
          }

          // 索引匹配，已经是推荐位，就不用替换了
          if (!isNotGood && !item.goods) {
            _advertisingSpacs = _advertisingSpacs.filter(curr => {
              return curr.index !== advertising.index;
            });
            _searchesList.splice(i, 0, advertising);
          }
          break;
        }

        // 过滤掉投放和坑位
        if (isNotGood || item.goods) {
          goodIndex = +goodIndex;
          continue;
        }

        goodIndex++;
      }
    });

    const goodCount = searchList.reduce((acc, cur) => {
      const isNotGood = [1, 2].includes(+(cur.bizType || 0)); // 投放和坑位
      const isHotGood = cur.goods && cur.goods.length > 0;
      return acc + (!isNotGood && !isHotGood ? 1 : 0);
    }, 0);
    console.log(_advertisingSpacs, insertIndex, '_advertisingSpacs')
    return {
      _searchesList,
      insertIndex: goodCount + (insertIndex || 0),
      advertisingSpacs: _advertisingSpacs,
    };
  }
}
